module.exports = __webpack_public_path__ + "dafa5313d964a67d48972ff36a90d318.svg";